<template>
  <div class="product-continue">
    <headBox title="产品续期政策" class="headerBox"> </headBox>

    <div class="header">
      <topSearchForm @search="searchAjax()" @export="daochu">
        <el-form :inline="true">
          <el-form-item label="产品名称" prop="pass" class="item">
            <el-input
              v-model="productName"
              clearable
              placeholder="请输入"
              style="width: 100%"
            ></el-input>
          </el-form-item>

          <!-- <el-form-item label="产品区分" prop="pass" class="item">
            <el-select v-model="renewalRateCode" placeholder="请选择" clearable>
              <el-option
                v-for="item in options"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </el-form-item> -->

          <el-form-item label="状态" prop="pass" class="item">
            <el-radio-group
              v-model="status"
              @change="getList()"
              style="width: 100%"
            >
              <el-radio :label="-1">全部</el-radio>
              <el-radio :label="2">上架</el-radio>
              <el-radio :label="1">下架</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </topSearchForm>
    </div>
    <div class="body">
      <div class="table">
        <div class="table-row head border-bottom">
          <div class="td big-td">产品名称</div>
          <!-- <div class="td big-td">产品区分</div> -->
          <div class="td big-td5">续期时间</div>
          <div class="td big-td5 big-td55">继续率要求</div>
          <div class="td big-td6 big-td66">继续率发放比例</div>
          <div class="td big-td2">其他规则</div>
        </div>
        <div
          class="table-row border-bottom"
          v-for="(item_1, index_1) in tableData"
          :key="index_1"
        >
          <div class="merge-td2 big-td">
            <div class="merge-td2-title">{{ item_1.name }}</div>
            <div class="merge-td2-code" v-if="item_1.status == 1">
              <span  class="soldOut">已下架</span>
            </div>
          </div>
          <!-- <div class="merge-td big-td">
            {{ item_1.rule.renewalRateConfig.name }}
          </div> -->
          <div class="box">
            <div
              class="table-row-child"
              v-for="(item_2, index_2) in item_1.rule.renewalRateConfig.payNums"
              :key="index_2"
            >
              <div class="merge-td big-td5">
                {{ item_2.payNumDesc || "--" }}
              </div>
              <div class="box">
                <div
                  class="table-row-child"
                  v-for="(item_3, index_3) in item_2.renewalRates"
                  :key="index_3"
                >
                  <div
                    class="td big-td5"
                    v-if="item_1.rule.renewalRateConfig.isCalRate"
                  >
                    <template v-if="item_3.max&&item_3.min">
                      <span v-if="item_3.min">{{ item_3.min }}%≤</span>
                      {{
                        item_1.rule.renewalRateConfig.type == 1
                          ? "产品继续率"
                          : "整体继续率"
                      }}
                      <span v-if="item_3.max">&lt;{{ item_3.max }}%</span>
                    </template>
                    <template v-else-if="item_3.min">
                      {{
                        item_1.rule.renewalRateConfig.type == 1
                          ? "产品继续率"
                          : "整体继续率"
                      }}
                      <span v-if="item_3.min">≥{{ item_3.min }}%</span>
                    </template>
                  </div>
                  <div class="td big-td5" v-else>无继续率要求</div>
                  <div class="td big-td6">{{ item_3.sendRate }}%</div>
                </div>
              </div>
            </div>
          </div>
          <div class="merge-td big-td2">{{ item_1.rule.renewalRecoverRule }}</div>
        </div>
      </div>
      <el-pagination
        class="page"
        background
        layout="total,prev, pager, next"
        @current-change="getList"
        :current-page.sync="pageNum"
        :page-size="pageSize"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import common from "@/api/common.js";
import { pageTool } from "@/api/mixins";
import headBox from "@/components/head.vue";
import topSearchForm from "@/components/topSearchForm";

//当前实例组件
export default {
  mixins: [pageTool],
  data: () => ({
    userInfo: {},
    renewalRateCode: "",
    productName: "",
    status: -1,
    tableData: [],
    form: {},
    options: [],
    params: {},
  }),
  components: { headBox, topSearchForm },
  created() {
    this.getData();
    this.initListAjax("/master/product/queryProductRuleList");
  },
  mounted() {
    this.userInfo = this.$tools.getLocal("userinfo");
  },
  methods: {
    setListParams(params) {
      params.productName = this.productName;
      params.renewalRateCode = this.renewalRateCode;
      if(this.status&&this.status!=-1){
        params.status = this.status;
      }
      return params
    },
    getData() {
      this.$http({
        url: "/master/policy/queryConfigList",
        type: "put",
        params: {},
      }).then((data) => {
        console.log(data, "shuju");
        this.options = data.data
      });
    },
    daochu(){
      const params = this.setListParams({});
      this.$tools.daochu("/master/product/exportProductRuleList",params);
    }
  },
};
</script>
<style lang="scss" scoped>
@import "./productContinue";
</style>
